import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ConfigurationsSoftSkillsDimensionsService from "../../../../services/api/configurations/ConfigurationsSoftSkillsDimensions.service";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import { useNotification } from "../../../notification.hook";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { UpdateSoftSkillsDimensionsConfig } from "../../../../types/api/configurations.type";
import { useEffect } from "react";

const MANAGE_CONFIG_SKILLS_DIMENSION_QUERY_KEY =
  "get-config-soft-skills-dimensions";

export const useManageSkillDimensions = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError } = useQuery({
    queryKey: [MANAGE_CONFIG_SKILLS_DIMENSION_QUERY_KEY, configYear],
    queryFn: () => ConfigurationsSoftSkillsDimensionsService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching };
};

export const useUpdateManageSkillDimensions = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["update-manage-skills-dimensions"],
    mutationFn: (result: UpdateSoftSkillsDimensionsConfig) =>
      ConfigurationsSoftSkillsDimensionsService.update(result),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MANAGE_CONFIG_SKILLS_DIMENSION_QUERY_KEY],
      });
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
    },
    onError: (error) => {
      console.error(`errore updating soft skills dimensions config: ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutate, isPending };
};
